export default function PauseIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 17'
        fill='currentColor'
      >
        <rect width='6' height='17' rx='1' />
        <rect x='10' width='6' height='17' rx='1' />
      </svg>
    </span>
  );
}
